import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { Button } from "reactstrap";
import { GetEventTrackings, EventTrackingsRequestState } from "../../../store/ScheduleSync/ScheduleSyncEventAction";
import StatusCode from "../../../util/StatusCode";
import ActiveToggle from "../../misc/ActiveToggle";
import ModalComponent from "../../misc/ModalComponent";
import TableHorizontal from "../../misc/TableHorizontal";
import { useTranslation } from "react-i18next";
import * as Helper from '../../../util/Helper';
import { RootState } from "../../../store/store";



const ScheduleSyncEventTrackings = () => {
    const { t } = useTranslation(['scheduleSync', 'common']);

    const { eventId } = useParams();
    const dispatch = useDispatch();
    const [targetData, setTargetData] = useState<string | undefined>(undefined);
    const [open, setOpen] = useState<boolean>(false);

    const trackings = useSelector<RootState, EventTrackingsRequestState>(state => state.schedulesync_events.eventTrackings);
    const [onlyActive, setOnlyActive] = useState(trackings?.onlyActive ?? true);

    useEffect(() => {
        if (eventId) {
            GetEventTrackings(eventId, onlyActive)(dispatch);
        }
    }, [dispatch, onlyActive, eventId]);

    const mapTrackings = () => {
        if (trackings.code !== StatusCode.COMPLETE) {
            return [];
        }
        return trackings.data.map(x => ({
            id: x.id,
            data: [
                { value: x.module && <Link to={`/module/${x.module.id}`}>{x.module.title}</Link> },
                { value: x.targetSystem },
                { value: x.targetId },
                { value: Helper.formatDate(x.exported) },
                { value: Helper.formatDate(x.exportedLastModified) },
                { value: Helper.active(x.active) },
                { value: x.targetData ? <Button style={{ whiteSpace: 'nowrap' }} onClick={() => (setOpen(true), setTargetData(x.targetData))}>{t('tracking.showInformation', {ns: 'scheduleSync'})}</Button> : '' }
            ]
        }));
    }

    const renderTrackings = () => (<>
        <h5 className="header-menu">{t('tracking.title', { ns: 'scheduleSync' })}</h5>
        <TableHorizontal
            header={[
                { value: t('tracking.tableHeaders.module', { ns: 'scheduleSync' }) },
                { value: t('tracking.tableHeaders.targetSystem', { ns: 'scheduleSync' }) },
                { value: t('tracking.tableHeaders.targetId', { ns: 'scheduleSync' }) },
                { value: t('tracking.tableHeaders.exported', { ns: 'scheduleSync' }) },
                { value: t('genericTableHeaders.modified', { ns: 'common' }) },
                { value: t('genericTableHeaders.active', { ns: 'common' }) },
                { value: t('commonTableHeaders.information', { ns: 'scheduleSync' }) }
            ]}
            info={mapTrackings()}
            error={trackings.code === StatusCode.ERROR}
            searching={trackings.code === StatusCode.PENDING}
            noResMsg={t('noResult.eventTrackings', { ns: 'scheduleSync' })}
        />
    </>);

    return (<>
        <div className="header_member_table large">{t('tracking.title', { ns: 'scheduleSync' })}
            <span className="right">
                <ActiveToggle
                    onlyActive={trackings?.onlyActive ?? true}
                    update={(active) => setOnlyActive(active)}
                    disabled={trackings.code === StatusCode.PENDING}
                />
            </span></div>
        {renderTrackings()}

        {open && targetData !== undefined &&
            <ModalComponent
                isOpen={open}
                toggleModal={() => (setOpen(false), setTargetData(undefined))}
                header={t('commonTableHeaders.information', { ns: 'scheduleSync' })}
                size="xl"
                cancel={t('action.close', { ns: 'common' })}
            >
                <div>
                    <pre>{Helper.formatText(targetData)}</pre>
                </div>
            </ModalComponent>}
    </>);
};

export default ScheduleSyncEventTrackings;
